import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from '../pages/Login/Login';
import Home from '../pages/Home/Home';
import Notification from '../pages/Notification/Notification';
import Follow from '../pages/Follow/Follow';
import Dashboard from '../pages/Dashboard/Dashboard';
import Documentation from '../pages/Documentation/Documentation';
import Settings from '../pages/Settings/Settings';
import Help from '../pages/Help/Help';
import Classroom from '../pages/Classroom/Classroom';
import Students from '../pages/Students/Students';
import Reports from '../pages/Reports/Reports';
import PersonalData from '../pages/PersonalData/PersonalData';
import ProtectedRoute from '../components/ProtectedRoute';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          <Login />
        } />

        <Route path="/" element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        } />

        <Route path="/notification" element={
          <ProtectedRoute>
            <Notification />
          </ProtectedRoute>
        } />

        <Route path="/follow" element={
          <ProtectedRoute>
            <Follow />
          </ProtectedRoute>
        } />

        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />

        <Route path="/documentation" element={
          <ProtectedRoute>
            <Documentation />
          </ProtectedRoute>
        } />

        <Route path="/settings" element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } />

        <Route path="/help" element={
          <ProtectedRoute>
            <Help />
          </ProtectedRoute>
        } />

        <Route path="/classroom" element={
          <ProtectedRoute>
            <Classroom />
          </ProtectedRoute>
        } />

        <Route path="/students" element={
          <ProtectedRoute>
            <Students />
          </ProtectedRoute>
        } />

        <Route path="/reports" element={
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        } />

        <Route path="/personal-data" element={
          <ProtectedRoute>
            <PersonalData />
          </ProtectedRoute>
        } />

        {/* TODO: Adicionar uma página 404 */}
        <Route path="*" element={
          <ProtectedRoute>
            <div>Página não encontrada</div>
          </ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}